import ScrollableGrid from './scrollable-grid';
import { nodeListToArray } from './utils';

window.addEventListener('DOMContentLoaded', () => {
	const nodes = nodeListToArray(
		document.querySelectorAll('.scrollable-grid')
	);
	const scrollables = nodes.map(element => new ScrollableGrid(element));
});
